<section class="operations-page">
    <header class="operations-page__header">
        <div>
            <h2 class="operations-page__title">Diagnostics</h2>
            <p class="operations-page__lead">Read-only webhook, subscription, and synchronization diagnostics.</p>
        </div>
        <div class="operations-actions">
            <button type="button"
                    class="operations-btn operations-btn--primary"
                    [disabled]="refreshing || loading"
                    (click)="refreshSynchronization()">
                {{ refreshing ? 'Refreshing…' : 'Refresh Synchronization' }}
            </button>
        </div>
    </header>

    <div class="subscription-consistency-banner subscription-consistency-banner--mismatch"
         *ngIf="mismatch"
         role="alert">
        <div class="subscription-consistency-banner__body">
            <strong>Subscription drift detected</strong>
            <p>KYRA and EEN subscription records do not match. Review synchronization before relying on provider event
                delivery.</p>
        </div>
    </div>

    <div class="subscription-consistency-banner subscription-consistency-banner--unverified"
         *ngIf="unverified"
         role="status">
        <div class="subscription-consistency-banner__body">
            <strong>Synchronization unverified</strong>
            <p>Subscription synchronization status could not be verified.</p>
        </div>
    </div>

    <div class="operations-page__card" *ngIf="loading">
        <p class="operations-page__loading">Loading diagnostics…</p>
    </div>

    <div class="operations-detail-grid" *ngIf="!loading">
        <app-metadata-panel title="Platform Diagnostics" [entries]="diagnosticsEntries"></app-metadata-panel>
        <app-metadata-panel title="Synchronization" [entries]="syncEntries"></app-metadata-panel>
        <app-metadata-panel
                title="KYRA ↔ EEN Consistency"
                [entries]="consistencySummaryEntries"
                *ngIf="consistencySummaryEntries.length"
        ></app-metadata-panel>
    </div>

    <div class="operations-page__card" *ngIf="!loading && attentionEntries.length">
        <h3 class="operations-page__heading">Attention summary</h3>
        <p class="operations-page__lead">
            Entries that need review (desired missing, KYRA only, EEN only, or unverified).
            This surface is read-only and does not mutate subscriptions.
        </p>
        <div class="operations-table-wrapper">
            <table class="operations-table">
                <thead>
                <tr>
                    <th>Category</th>
                    <th>Organization</th>
                    <th>Cameras</th>
                    <th>Provider</th>
                    <th>Event types</th>
                    <th>Environment</th>
                    <th>Local</th>
                    <th>Remote</th>
                    <th>Detail</th>
                </tr>
                </thead>
                <tbody>
                <tr *ngFor="let entry of attentionEntries">
                    <td>{{ categoryLabel(entry.category) }}</td>
                    <td>{{ organizationLabel(entry) }}</td>
                    <td>{{ (entry.camera_ids || []).join(', ') || '—' }}</td>
                    <td>{{ consistencyReport?.provider_label || '—' }}</td>
                    <td>{{ (entry.event_types || []).join(', ') || '—' }}</td>
                    <td>{{ (entry.owner_environment || 'unknown').toUpperCase() }}</td>
                    <td>{{ entry.local_status || '—' }}</td>
                    <td>{{ entry.remote_state || '—' }}</td>
                    <td>{{ entry.detail || '—' }}</td>
                </tr>
                </tbody>
            </table>
        </div>
    </div>
</section>
